import React, { Fragment } from "react";
import { print } from "graphql";
import { Mutation } from "@apollo/client/react/components";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import SimpleModal from "../../SimpleModal";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import UISchemaResolver from "../../../data/schema/form_ui/_resolver";
import PrefillUtil from "../../../global/utils/prefillHelper";
import GQLUtil from "../../../global/utils/gqlHelper";
import { connect } from "react-redux";
import FormExit from "../../SimpleForm/UI/FormExit";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import {
  GET_9089_FORM_DATA,
  UPDATE_9089_FORM,
  SUBMIT_9089_FORM,
  GET_9089_PROFILES,
} from "./queries";
import { cleanData } from "./helpers.js";
import renderFormActions from "../renderFormActions";
import renderDeleteButton from "../renderDeleteButton";
import renderSaveButton from "../renderSaveButton";
import util from "../../Utils/mappers";
import isTester from "../../SimpleForm/SubmissionUtilities/isTester";
import FullScreenSpinner from "../../../global/components/FullScreenSpinner";
import { fetchAllReferenceData } from "../../../global/app/actions/actions_reference";

class Form9089 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closeModal: false,
      modalOpen: true,
      profiles: [],
      counties: undefined,
      formData:
        (this.props.history.location.state &&
          this.props.history.location.state.initialValues) ||
        {},
      form_ui: undefined,
      formSubmitting: false,
      reuseMetadata: undefined,
      reuse:
        (this.props.history.location.state &&
          this.props.history.location.state.reuse) ||
        false,
    };
  }

  componentDidMount = async () => {
    const application_type = "9089";
    const application_id = this.props.match.params.id;

    // if user is currently in app and reference data updates we want to fetch latest data when they open up the form
    // before we were checking if data existed in redux and if so skipping the fetch and not getting the latest data
    this.props.dispatch(fetchAllReferenceData());

    const profiles = await GQLUtil.genericGQLQuery(print(GET_9089_PROFILES));
    const profiles_parsed = PrefillUtil.getPrefillProfileOptions(
      profiles.data.getUserProfileInfo,
      application_type,
      "all"
    );

    const form = await GQLUtil.genericGQLQuery(print(GET_9089_FORM_DATA), {
      id: application_id,
    });

    util
      .getCounties()
      .then((data) => this.setState({ counties: data }))
      .catch((e) => {
        console.log(`unable to fetch counties. Error:\n${e}\n`);
      });

    let formData = form.data.getForm9089ById.payload;
    if (form.data !== null) {
      let form_ui = form.data.getForm9089ById.form_ui;
      const reuseMetadata = form?.data?.getForm9089ById?.reuseMetadata;

      this.setState({
        profiles: profiles_parsed,
        reuseMetadata: reuseMetadata,
        formData,
        form_ui,
      });
    }

    if (
      this.props.history.location.state &&
      this.props.history.location.state.initialValues
    ) {
      const reuseMetadata = form?.data?.getForm9089ById?.reuseMetadata;
      this.setState({
        formData: {
          ...this.props.history.location.state.initialValues,
          ...(formData ?? {}),
        },
        reuseMetadata: reuseMetadata,
      });
    }
  };
  render9089 = () => {
    const application_type = "9089";
    const resolverName = "SubmitForm9089";
    const application_id = this.props.match.params.id;
    const useRecaptcha = this.props.user?.Recaptcha !== false;
    const { executeRecaptcha } = useRecaptcha
      ? this.props.googleReCaptchaProps
      : {};

    const handleToggle = () => {
      this.setState({ closeModal: !this.state.closeModal });
    };

    const renderFormExit = (values, form_ui, form_ui_name) => {
      return (
        <FormExit
          renderDeleteButton={() =>
            renderDeleteButton(
              application_id,
              application_type,
              this.props.history,
              values,
              this.props.user.GroupRole
            )
          }
          renderSaveButton={() =>
            renderSaveButton(
              UPDATE_9089_FORM,
              values,
              "Form9089FormData",
              application_id,
              cleanData,
              this.props.history,
              "Save as Initiated",
              undefined,
              undefined,
              form_ui,
              form_ui_name
            )
          }
          closeModal={this.state.closeModal}
          toggleModal={handleToggle}
          values={values}
        />
      );
    };
    const setFormSubmittingState = (booleanValue) => {
      this.setState({ formSubmitting: booleanValue });
    };

    const formSubmissionError = (e, application_id) => {
      let type;
      let error = JSON.stringify(e);
      setFormSubmittingState(false);

      if (
        e &&
        e.graphQLErrors &&
        e.graphQLErrors[0] &&
        e.graphQLErrors[0].extensions
      ) {
        error = e.graphQLErrors[0].extensions;
      }
      if (
        e &&
        e.graphQLErrors &&
        e.graphQLErrors[0] &&
        e.graphQLErrors[0].message
      ) {
        type = e.graphQLErrors[0].message;
      }
      this.props.history.push({
        pathname: "/dashboard/error",
        state: {
          formType: application_type,
          error,
          application_id,
          type,
        },
      });
    };
    const formSubmissionSuccess = (res) => {
      const queueError = res?.[`${resolverName}`] === "queue_error";
      setFormSubmittingState(false);
      this.props.history.push({
        pathname: "/dashboard/success",
        state: { formType: application_type, queueError },
      });
    };

    return (
      <Fragment>
        {!this.state.modalOpen ? (
          <Redirect to="/dashboard/application" />
        ) : (
          <SimpleModal
            fullscreen={true}
            toggleModal={handleToggle}
            modalStatus={this.state.modalOpen}
          >
            <Mutation
              onError={(e) => formSubmissionError(e, application_id)}
              onCompleted={(e) => formSubmissionSuccess(e)}
              mutation={SUBMIT_9089_FORM}
            >
              {(SubmitForm9089) => (
                <SimpleForm
                  handleSubmit={
                    useRecaptcha
                      ? async (values) => {
                          if (!executeRecaptcha) {
                            return;
                          }
                          const token = await executeRecaptcha(resolverName);
                          setFormSubmittingState(true);
                          SubmitForm9089({
                            variables: {
                              Form9089FormData: cleanData(values),
                              id: application_id,
                              token: token,
                            },
                          });
                        }
                      : (values) => {
                          setFormSubmittingState(true);
                          SubmitForm9089({
                            variables: {
                              Form9089FormData: cleanData(values),
                              id: application_id,
                            },
                          });
                        }
                  }
                  history={this.props.history}
                  toggleClose={handleToggle}
                  toggleModal={handleToggle}
                  formExit={this.state.closeModal}
                  renderFormExit={renderFormExit}
                  reuseMetadata={this.state.reuseMetadata}
                  renderFormActions={renderFormActions(
                    UPDATE_9089_FORM,
                    "Form9089FormData",
                    application_id,
                    cleanData,
                    this.props.history,
                    this.state.formSubmitting,
                    true // hasSubmitConfirmation
                  )} // override default FormActions
                  formSaveMutation={UPDATE_9089_FORM}
                  formSaveMutationCallback={({
                    formValues,
                    formUIData,
                    saveForm,
                    profilePrefillMetadata,
                  }) => {
                    saveForm({
                      variables: {
                        formUI9089: formUIData,
                        Form9089FormData: cleanData(formValues),
                        id: application_id,
                        profilePrefillMetadata: profilePrefillMetadata.profiles,
                      },
                    });
                  }}
                  multiPage={true}
                  uiSchema={UISchemaResolver(application_type)}
                  uiSchema_meta={UISchemaResolver(`${application_type}-meta`)}
                  uiSchema_nav={UISchemaResolver(`9089-nav`)}
                  uiSchema_lookup={UISchemaResolver(
                    `${application_type}-lookup`
                  )}
                  inputResolver={inputResolver}
                  initialValues={this.state.formData || {}}
                  profiles={this.state.profiles}
                  counties={this.state.counties}
                  form_ui={this.state.form_ui}
                  form_ui_name={"formUI9089"}
                  formSubmitting={this.state.formSubmitting}
                  returningToForm={this.state.reuse}
                  displayFormWarnings={true}
                  disableValidation={
                    (this.props.user &&
                      this.props.user.Roles &&
                      isTester(this.props.user && this.props.user.Roles)) ||
                    false
                  }
                />
              )}
            </Mutation>
          </SimpleModal>
        )}
      </Fragment>
    );
  };

  render() {
    if (this.state.formData !== undefined && this.state.form_ui !== undefined) {
      return <div>{this.render9089()}</div>;
    }
    return <FullScreenSpinner />;
  }
}

const mapStateToProps = (state) => ({
  user: state.appReducer.userDataReducer.data,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const ConnectedForm = connect(mapStateToProps, mapDispatchToProps)(Form9089);
const RoutedForm = withRouter(ConnectedForm);

const FormWrapper = (props) => {
  const useRecaptcha = props.user?.Recaptcha !== false;
  const ComponentToRender = useRecaptcha
    ? withGoogleReCaptcha(RoutedForm)
    : RoutedForm;

  return <ComponentToRender {...props} />;
};

export default FormWrapper;
